export const ONE_TIME_QUERY = ['focus_event', 'exclusive_condition', 'exclusive_promoter', 'exclusive_feature']
export const EXCLUSIVE_CONDITION_QUERY = 'exclusive_condition'
export const EXCLUSIVE_PROMOTER_QUERY = 'exclusive_promoter'
export const EXCLUSIVE_FEATURE_QUERY = 'exclusive_feature'
// 特集ページで cookie の都道府県絞り込みを、その都道府県が属する地方まで広げるためのパラメータ
export const INCLUDE_REGION_EVENTS_QUERY = 'include_region_events'
export const EXCLUSIVE_QUERY = ['filter[region]', 'filter[area_group]', 'filter[area]', 'filter[prefecture]']
